import * as actionTypes from "./actionTypes";
import standardReducer from "../common/standardReducer";

export default standardReducer(actionTypes);
